import React from 'react';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile } from '../../../../redux/selectors';
import { SignInMobile } from './components/mobile';
import { SignInWeb } from './components/web';
export var SignInScreen = function () {
    var isMobile = useAppSelector(getIsMobile);
    return isMobile ? React.createElement(SignInMobile, null) : React.createElement(SignInWeb, null);
};
